<!--中科泛在看板-->
<template>
  <div class="overviewBody">
    <!--大背景-->
    <div class="ubiquBody">
      <div class="topPart flexCenter">
        {{named}}
      </div>
      <div class="infoDiv flexBetween">
        <div class="leftPart">
          <div class="flexBetween unitInfo">
            <div class="flexCenterColumn">
              <p>单位用量</p>
              <p>{{unitUsePower}}</p>
            </div>
            <div class="flexCenterColumn">
              <p>设备总量</p>
              <p>{{deviceCount}}</p>
            </div>
            <div class="flexCenterColumn">
              <p>配电房总量</p>
              <p>{{roomCount}}</p>
            </div>
          </div>
          <realTimeLoad class="eventPie titleBoxBg"> </realTimeLoad>
          <companyInfo class="leftCompanyInfo titleBoxBg"> </companyInfo>
          <eventPie class="leftPieChart boxBg"> </eventPie>
          <newstEvent class="newstEvent rateBoxBg"> </newstEvent>
        </div>
        <div class="centerPart">
          <div class="centerMap">
            <centerMap></centerMap>
          </div>
          <div class="centerOrderBox flexBetween">
            <orderBar class="orderBar titleBoxBg"> </orderBar>
            <orderPie class="orderPie titleBoxBg"> </orderPie>
          </div>
          <newstOrder class="newstOrder titleBoxBg"> </newstOrder>
        </div>
        <div class="rightPart">
          <div class="flexBetween unitInfo">
            <div class="flexCenterColumn">
              <p>年能耗量</p>
              <p>{{yearUsePower}}</p>
            </div>
            <div class="flexCenterColumn">
              <p>月能耗量</p>
              <p>{{monthUsePower}}</p>
            </div>
            <div class="flexCenterColumn">
              <p>日能耗量</p>
              <p>{{dayUsePower}}</p>
            </div>
          </div>
          <usePower class="usePower titleBoxBg"> </usePower>
          <ringInfo class="rightDH titleBoxBg"> </ringInfo>
          <onlineSupport class="onlineSupport titleBoxBg"> </onlineSupport>
          <onlineShop class="onlineShop rateBoxBg"> </onlineShop>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import companyInfo from '@/page/projectDingZhi/Ubiquitous/companyInfo.vue'
  import ringInfo from '@/page/projectDingZhi/Ubiquitous/ringInfo.vue'
  import onlineShop from '@/page/projectDingZhi/Ubiquitous/onlineShop.vue'
  import onlineSupport from '@/page/projectDingZhi/Ubiquitous/onlineSupport.vue'
  import realTimeLoad from '@/page/projectDingZhi/Ubiquitous/realTimeLoad.vue'
  import eventPie from '@/page/projectDingZhi/Ubiquitous/eventPie.vue'
  import newstEvent from '@/page/projectDingZhi/Ubiquitous/newstEvent.vue'
  import usePower from '@/page/projectDingZhi/Ubiquitous/usePower.vue'
  import newstOrder from '@/page/projectDingZhi/Ubiquitous/newstOrder.vue'
  import orderPie from '@/page/projectDingZhi/Ubiquitous/orderPie.vue'
  import orderBar from '@/page/projectDingZhi/Ubiquitous/orderBar.vue'
  import centerMap from '@/page/projectDingZhi/Ubiquitous/centerMap.vue'

  export default {
    components: {
      companyInfo,
      ringInfo,
      onlineShop,
      onlineSupport,
      realTimeLoad,
      eventPie,
      newstEvent,
      usePower,
      newstOrder,
      orderPie,
      orderBar,
      centerMap
    },
    props: {},
    data () {
      return {
        named: getName(),
        isFull: false,
        unitUsePower: 0,
        deviceCount: 0,
        roomCount: 0,
        yearUsePower: 0,
        monthUsePower: 0,
        dayUsePower: 0,
      }
    },
    created () {
      debugPage=this
    },
    mounted () {
      //隐藏左侧和顶部并且全屏
      // this.$dialogMethod.showMessage("点击右上角缩放按钮进入全屏!")
      //加载数据
      var axios=require('axios')
      axios({
        url: "/static/中科泛在定制/看板/数据/info.json",
      }).then(respon => {
        var data=JSON.parse(JSON.stringify(respon.data))
        //单位信息
        this.unitUsePower=data.unitInfo.unitUsePower
        this.deviceCount=data.unitInfo.deviceCount
        this.roomCount=data.unitInfo.roomCount
        //能耗信息
        this.yearUsePower=data.unitUsePowerInfo.yearUsePower
        this.monthUsePower=data.unitUsePowerInfo.monthUsePower
        this.dayUsePower=data.unitUsePowerInfo.dayUsePower
      })
      addNewTask("checkUbiquitousIsFull",0,1000,-1,() => {
        if(document.fullscreenElement||
          document.msFullscreenElement||
          document.mozFullScreenElement||
          document.webkitFullscreenElement||false) {
          this.$store.menuStore.state.showTopMenu=false
          this.$store.menuStore.state.showLeftMenu=false
        } else {
          this.$store.menuStore.state.showTopMenu=true
          this.$store.menuStore.state.showLeftMenu=true
        }
      })
    },
    destroyed () {
      removeTask("checkUbiquitousIsFull")
    },
    computed: {},
    watch: {},
    methods: {
      fullScreen () {
        if(this.isFullscreen()==false) {
          this.isFull=true
          var el=document.documentElement;
          var rfs=el.requestFullScreen||el.webkitRequestFullScreen||el.mozRequestFullScreen||el.msRequestFullscreen;
          if(typeof rfs!="undefined"&&rfs) {
            rfs.call(el);
          };
        } else {
          this.isFull=false
          if(document.exitFullscreen) {
            document.exitFullscreen();
          } else if(document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
          } else if(document.webkitCancelFullScreen) {
            document.webkitCancelFullScreen();
          } else if(document.msExitFullscreen) {
            document.msExitFullscreen();
          }
          if(typeof cfs!="undefined"&&cfs) {
            cfs.call(el);
          }
        }
      },
      isFullscreen () {
        return document.fullscreenElement||
          document.msFullscreenElement||
          document.mozFullScreenElement||
          document.webkitFullscreenElement||false;
      }
    }
  }
</script>

<style scoped>
  .flexCenter {
    font-size: 30px;
    color: #fff;
    letter-spacing: 3px;
    font-weight: bold;
  }

  .rateBoxBg,
  .titleBoxBg,
  .boxBg,
  .overviewBody {
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }

  .rateBoxBg {
    background-image: url(/static/中科泛在定制/看板/rateBoxBg.png);
  }

  .titleBoxBg {
    background-image: url(/static/中科泛在定制/看板/titleBoxBg.png);
  }

  .boxBg {
    background-image: url(/static/中科泛在定制/看板/boxBg.png);
  }

  .ubiquBody {
    background-image: url(/static/中科泛在定制/看板/overViewBg.png);
    /*width: 100%;
		height: 100%;*/
    background-size: 100% 100%;
    background-repeat: no-repeat;
    min-width: 1890px;
  }

  .topPart {
    align-items: flex-start;
    overflow: hidden;
  }

  .infoDiv {
    width: calc(100% - 60px);
    margin-top: 29px;
    padding: 0 30px;
  }

  .leftPart,
  .centerPart,
  .rightPart {
    display: inline-flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
  }

  .leftPart {
    width: 482px;
  }

  .unitInfo {
    width: 100%;
  }

  .unitInfo>div {
    height: 77px;
    width: 30%;
    background-image: url(../../../../public/static/中科泛在定制/看板/littleBoxBg.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }

  .unitInfo>div>p:first-child {
    color: #9FCEFF;
    font-size: 12px;
  }

  .unitInfo>div>p:last-child {
    color: #FFA657;
    font-size: 22px;
    margin-top: 10px;
  }

  .eventPie {
    width: 100%;
    height: 278px;
    justify-content: flex-start;
    margin-top: 22px;
  }

  .leftCompanyInfo {
    width: 100%;
    height: 201px;
    margin-top: 20px;
  }

  .leftPieChart {
    width: 100%;
    height: 218px;
    margin-top: 20px;
  }

  .newstEvent {
    width: 100%;
    height: 119px;
    margin-top: 21px;
  }

  .centerPart {
    width: 814px;
  }

  .centerMap {
    width: 100%;
    height: 580px;
  }

  .centerOrderBox {
    width: 100%;
  }

  .orderBar {
    width: 100%;
    height: 242px;
  }

  .orderPie {
    width: 100%;
    height: 242px;
  }

  .newstOrder {
    width: 100%;
    height: 130px;
    margin-top: 20px;
  }

  .rightPart {
    width: 504px;
  }

  .usePower {
    width: 100%;
    height: 237px;
    margin-top: 20px;
  }

  .rightDH {
    width: 100%;
    height: 154px;
    margin-top: 20px;
  }

  .onlineSupport {
    width: 100%;
    height: 178px;
    margin-top: 20px;
  }

  .onlineShop {
    width: 100%;
    height: 243px;
    margin-top: 20px;
  }
</style>